import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";
import L from "../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import PortalSwitcher from "../PortalSwitcher";
import s from "./homeLanding.module.css";

export default function LandingNav({
  mode = "platform",
  brandName,
  brandTo = "/",
  showPortalSwitcher = false,
  showFindClub = true,
  showTryCta = true,
  showLoginCta = true,
  tryCtaLabel,
  loginCtaLabel = "Войти",
  extraActions,
}) {
  const title = brandName || L.productName;
  const tryLabel = tryCtaLabel || `Попробовать`;

  return (
    <nav className={s.nav}>
      <Link to={brandTo} className={s.navBrand}>
        <img src={logo} alt="" className={s.navLogo} />
        <span className={s.navBrandText}>{title}</span>
      </Link>
      <div className={s.navLinks}>
        {showPortalSwitcher ? (
          <PortalSwitcher variant="landing" />
        ) : null}
        {mode === "club" ? (
          <>
            <a href="#showcase" className={`${s.btn} ${s.btnGhost}`}>
              Приложение
            </a>
            <a href="#portals" className={`${s.btn} ${s.btnGhost}`}>
              Порталы
            </a>
          </>
        ) : null}
        {showLoginCta && mode === "platform" ? (
          <Link to="/account/login" className={`${s.btn} ${s.btnOutline} ${s.navBtnCompact}`}>
            {loginCtaLabel}
          </Link>
        ) : null}
        {mode === "club" ? (
          <Link to="/book" className={`${s.btn} ${s.btnPrimary}`}>
            Записаться
          </Link>
        ) : null}
        {showTryCta && mode === "platform" ? (
          <Link
            to="/register-clinic"
            className={`${s.btn} ${s.btnPrimary} ${s.navBtnCompact}`}
            title={`${TRIAL_DAYS} дней бесплатно`}
            onClick={trackTryClick}
          >
            {tryLabel}
          </Link>
        ) : null}
        {extraActions}
      </div>
    </nav>
  );
}
